export default __webpack_public_path__ + "static/media/suggestion-chips-watson-actions5.137332d5.png";